import { render, staticRenderFns } from "./AddRole2Api.vue?vue&type=template&id=14bc3875"
import script from "./AddRole2Api.vue?vue&type=script&lang=js"
export * from "./AddRole2Api.vue?vue&type=script&lang=js"
import style0 from "./AddRole2Api.vue?vue&type=style&index=0&id=14bc3875&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports